import {
  Grid,
  IconButton,
  IconButtonProps,
  makeStyles
} from '@material-ui/core';
import { Info } from '@material-ui/icons';
import React, { FC } from 'react';

const useStyles = makeStyles(theme => ({
  button: {
    padding: theme.spacing(1) / 2
  },
  icon: {
    fontSize: '1rem'
  },
  amount: {
    fontSize: '0.9rem',
    fontWeight: 900
  }
}));

type InfoButtonProps = IconButtonProps & {
  amount?: number;
  onClick: () => void;
};

const InfoButton: FC<InfoButtonProps> = (props: InfoButtonProps) => {
  const { name, onClick, ...others } = props;
  const classes = useStyles();
  return (
    <IconButton
      color="inherit"
      aria-label="show info"
      onClick={onClick}
      {...others}
      className={classes.button}
    >
      <Grid container direction="column" alignItems="center">
        <Info style={{ fontSize: '1.5rem' }} className={classes.icon} />
      </Grid>
    </IconButton>
  );
};

export default InfoButton;
